module.exports = __webpack_public_path__ + "deals.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/deals.svg
// module id = 117
// module chunks = 0